import React from "react";

function MediaFilter(props) {
    const {name, options, onChange, defaultOptionName, selected} = props;

    return (
        <select className={'select'} name={name} onChange={onChange} value={selected}>
                <option key={0} value={0}>
                    {defaultOptionName}
                </option>
            {options.map((option) => (
                <option key={option.term_id} value={option.term_id}>
                    {option.name}
                </option>
            ))}
        </select>
    );
}

export default MediaFilter;
